var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.visible,"timeout":2000,"color":"success"},on:{"input":_vm.setVisible}},[_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$tc(_vm.message)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }